/*
 * This file is part of sepia-themes.
 * Copyright (C) 2024 Data Futures GmbH.
 *
 * sepia-themes is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

import React from "react";

import {
  SearchAppFacets,
  SearchAppResultsPane,
} from "@js/invenio_search_ui/components";

import { SearchBar } from "react-searchkit";
import { Button, Container, Grid } from "semantic-ui-react";
import { GridResponsiveSidebarColumn } from "react-invenio-forms";

import { i18next } from "@translations/invenio_communities/i18next";

/**
 * High-Order component to generate custom Search Layout for user Dashboard.
 * @param {string} searchBarPlaceholder Search bar placeholder text.
 * @param {string} appName Name of the application context where the component is defined.
 * @returns {function} React component.
 */
const DashboardSearchLayoutHOC = ({ searchBarPlaceholder, appName }) => {
  const CommunitiesSearchLayout = (props) => {
    const [sidebarVisible, setSidebarVisible] = React.useState(false);
    const { config } = props;

    return (
      <Container>
        <Grid>
          <Grid.Row>
            <Grid.Column
              only="mobile tablet"
              mobile={2}
              tablet={1}
              verticalAlign="middle"
              className="mt-10"
            >
              <Button
                basic
                icon="sliders"
                onClick={() => setSidebarVisible(true)}
                aria-label={i18next.t("Filter results")}
              />
            </Grid.Column>
            <Grid.Column
              mobile={14}
              tablet={14}
              computer={12}
              floated="right"
              className="mt-10"
            >
              <SearchBar placeholder={searchBarPlaceholder} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <GridResponsiveSidebarColumn
              width={4}
              open={sidebarVisible}
              onHideClick={() => setSidebarVisible(false)}
              // eslint-disable-next-line react/no-children-prop
              children={
                <SearchAppFacets aggs={config.aggs} appName={appName} />
              }
            />
            <Grid.Column mobile={16} tablet={16} computer={12}>
              <SearchAppResultsPane
                layoutOptions={config.layoutOptions}
                appName={appName}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  };

  return CommunitiesSearchLayout;
};

/**
 * Components metadata.
 */
export const componentsMetadata = {
  "InvenioCommunities.Search.SearchApp.layout": DashboardSearchLayoutHOC({
    searchBarPlaceholder: i18next.t("Search in my communities..."),
    appName: "InvenioCommunities.Search",
  }),
  "InvenioAppRdm.DashboardCommunities.SearchApp.layout":
    DashboardSearchLayoutHOC({
      searchBarPlaceholder: i18next.t("Search in my communities..."),
      appName: "InvenioAppRdm.DashboardCommunities",
    }),
};
